export const user = `
{
    "User":  {
        "_product_view": {
            "af_content_id": 925667633,
            "last": 1557129362
        },
        "last_app_opened": 1560750114,
        "last_install": 1557129131,
        "last_view_listing": 1557191438,
        "last_product_view": 1557129362,
        "last_search": 1557129450,
        "installed_at": 1557129090,
        "_view_listing": {
            "af_content_list": [ 2047992365, 1058801283, 1067116507 ],
            "last": 1557191438
        },
        "last_seen": 1560750114
    }
}
`;


